<template>
  <v-text-field
    id="mapSearchBox"
    v-model="searchValue"
    class="d-flex mx-4 map-search__input"
    placeholder="Search by map name..."
    prepend-inner-icon="mdi-magnify"
    append-inner-icon="mdi-close"
    variant="solo"
    density="compact"
    rounded
    single-line
    @click:append-inner="$emit('clear-search')"
    @keydown="$emit('on-keydown', $event)"
    @input="$emit('update-search-term', $event.value)"
  />
</template>

<script>
export default {
  name: 'MapSearchBar',
  emits: ['update:modelValue', 'clear-search', 'update-search-term', 'on-keydown'],
  computed: {
    searchValue: {
      get() {
        return this.searchValue;
      },
      set(newVal) {
        this.$emit('update:modelValue', newVal);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.map-search__input {
  display: flex;
  width: 55%;
  :deep(.v-input__control) {
    width: 150vh;
  }
  :deep(.v-field__input) {
    padding-bottom: 5px;
  }
}
</style>
